import { render } from "./Home.vue?vue&type=template&id=efe2b61e&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=efe2b61e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-efe2b61e"

export default script